export default __webpack_public_path__ + "static/wemoney-rates-2022-f802a4ca24da9f909b3ec7aacd8d54d3.svg";